import styled, { css } from 'styled-components';

const Header = styled.th`
  text-align: ${(props) => props.align || 'left'};

  ${(props) =>
    props.fixed &&
    css`
      position: sticky;
      z-index: 3;
      background-color: white;

      width: ${props.width};
      left: ${props.left};
    `}
`;

export default Header;
